import React from 'react';
import { Info } from 'lucide-react';

function DataBanner() {
  return (
    <div style={{
      backgroundColor: 'rgba(0, 217, 255, 0.06)',
      border: '1px solid rgba(0, 217, 255, 0.15)',
      borderRadius: '10px',
      padding: '14px 20px',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      <Info size={18} color="#00d9ff" style={{ flexShrink: 0 }} />
      <p style={{
        fontSize: '13px',
        color: '#94a3b8',
        margin: 0,
        lineHeight: '1.5'
      }}>
        Data is sourced from third-party providers and may not reflect real-time odds. Always verify lines directly with your sportsbook before placing any wagers.
      </p>
    </div>
  );
}

export default DataBanner;
